<template>
    <div id="emoji-picker">
        <VEmojiPicker @select="selectEmoji" />
    </div>
</template>

<script>
import { VEmojiPicker, emojisDefault, categoriesDefault } from "v-emoji-picker";

export default {
    components: {
        VEmojiPicker,
    },
    data: () => ({}),
    props: {
        onPickedEmoji: {
            type: Function,
            required: true,
        },
    },
    methods: {
        selectEmoji(emoji) {
            this.onPickedEmoji(emoji);
        },
    },
};
</script>
